import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import appointmentDataSlice from './slices/AppointmentSlice';
import { createResetMetaReducer } from './slices/ResetSlice';
import authReducer from './slices/auth/AuthSlice';
import stockDataSlice from './slices/StockReportSlice';
import financialYearDataSlice from './slices/FinancialYearDataSlice';
import reportSlice from './slices/ReportSlice';

const resetSlices = ['auth', 'stockReportData', 'financialData', 'report'];

const persistConfig = {
  key: 'root',
  storage,
  whitelist: resetSlices,
};

const rootReducer = createResetMetaReducer(
  'GLOBAL_RESET',
  resetSlices,
)(
  combineReducers({
    auth: authReducer,
    appointmentData: appointmentDataSlice,
    stockReportData: stockDataSlice,
    financialData: financialYearDataSlice,
    report: reportSlice,
  }),
);

export default persistReducer(persistConfig, rootReducer);
